// src/hooks/useFeatureFlags.js
// Hook centralizado para los flags de organizacion que llegan en `authUser`
// (persistido por AuthProvider desde la respuesta de Flask /auth/login y /auth/refresh).
//
// Fuente de verdad: HPYME.dbo.Organizations, propagado via JWT.

import { useAuth } from '../context/AuthContext';
import { useMemo } from 'react';

export const useFeatureFlags = () => {
  const { user } = useAuth();

  return useMemo(() => {
    const priceRoundingStep = Number(user?.priceRoundingStep) || 0;
    // El redondeo se resuelve POR MARCA dentro de la base de datos del tenant
    // (solo ARCURI en GIULIANO). Cuando es true, el precio que llega del backend
    // ya es el precio de presentacion final y la UI no debe volver a redondear.
    const isBrandScopedRounding = !!user?.brandScopedPriceRounding;

    return {
      isCreditCardMarkupEnabled: !!user?.creditCardMarkupEnabled,
      priceRoundingStep,
      isBrandScopedRounding,
      // Indica si la aplicacion debe redondear (modo uniforme, ej. CIA).
      shouldRoundInApp: !isBrandScopedRounding && priceRoundingStep > 0,
      // GIULIANO: el buscador no muestra el codigo interno de producto.
      hideProductCodeColumn: !!user?.hideProductCodeColumn,
      // GIULIANO: no mostrar el badge de validacion de calculo (carrito y factura).
      hideCalculationValidationBadge: !!user?.hideCalculationValidationBadge,
    };
  }, [
    user?.creditCardMarkupEnabled,
    user?.priceRoundingStep,
    user?.brandScopedPriceRounding,
    user?.hideProductCodeColumn,
    user?.hideCalculationValidationBadge,
  ]);
};